import { createSlice } from "@reduxjs/toolkit";
import { getInquiries , editInquiry, createInquiry, getPriorityInquiries ,inquiryArchive, getInquiryById,getInquirySources} from "../../builders/inquiry/inquiry.builder";
const initialState = {
  // telephonicTableData: [],
  // walkinTableData: [],
  allInquiryData: [],
  priorityInquiryData:[],
  formEditId : null,
  // formAddId : null,
  loading : false,
  inquiryType: 'telephonic',
  inquiryById: null,
  inquiryByWalkin: null,
  archive: null,
  dateFrom: '',
  dateTo: '',
  inquiryPageData:{},
  inquirySources : []
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryType:(state, action)=>{
      state.inquiryType = action.payload
    },
    setFormEditId : (state, action) => {
      state.formEditId =  action.payload
    },
    setInquiryByWalkin:(state, action) =>{
      state.inquiryByWalkin = action.payload
    },
    setDateFrom: (state, action) => {
      state.dateFrom = action.payload;
    },
    setDateTo: (state, action) => {
      state.dateTo = action.payload;
    },
    setInquiryPageData: (state, action) => {
      state.inquiryPageData = action.payload;
    },
    clearExtraReducers : (state) => {
      // state.telephonicTableData = [],
      // state.walkinTableData = [],
      state.allInquiryData = [],
      state.priorityInquiryData = [],
      state.formAddId = null,
      state.loading = false
      state.formEditId = null,
      state.dateFrom = '',
      state.dateTo = '',
      state.inquiryPageData = {}
      state.inquiryById = null
      state.inquiryByWalkin = null
      state.inquirySources = []
  } 
  },
  extraReducers: (builder) => {
    builder.addCase(getInquiries.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getInquiries.fulfilled, (state, action) => {
      // const telephonicInquries = action.payload?.filter(e=> e.inquiryType === 'telephonic')
      // const walkinInquries = action.payload?.filter(e=> e.inquiryType === 'walkin')
      // state.telephonicTableData = telephonicInquries  
      // state.walkinTableData = walkinInquries  
      state.allInquiryData = action.payload
      state.loading = false
    });
    builder.addCase(getInquiries.rejected, (state) => {
      state.loading = false
      state.allInquiryData=[]
    });
    builder.addCase(editInquiry.pending, (state) => {
      state.loading = true
    });
    builder.addCase(editInquiry.fulfilled, (state) => {
      state.loading = false
      
    });
    builder.addCase(editInquiry.rejected, (state) => {
      state.loading = false
    });
    builder.addCase(createInquiry.pending, (state) => {
      state.loading = true
    });
    builder.addCase(createInquiry.fulfilled, (state) => {
      state.loading = false
    });
    builder.addCase(createInquiry.rejected, (state) => {
      state.loading = false
   
    });
    builder.addCase(getPriorityInquiries.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getPriorityInquiries.fulfilled, (state, action) => {
      state.priorityInquiryData = action.payload
      state.loading = false
    });
    builder.addCase(getPriorityInquiries.rejected, (state) => {
      state.loading = false
    });
    builder.addCase(inquiryArchive.pending, (state) => {
      state.loading = true
    });
    builder.addCase(inquiryArchive.fulfilled, (state) => {
      state.loading = false
    });
    builder.addCase(inquiryArchive.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getInquirySources.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getInquirySources.fulfilled, (state, action) => {
      state.loading = false
      state.inquirySources = action.payload
    });
    builder.addCase(getInquirySources.rejected, (state) => {
      state.loading = false
    });
    builder.addCase(getInquiryById.pending, (state) => {
      state.loading = true
    });
    builder.addCase(getInquiryById.fulfilled, (state, action) => {
      state.inquiryById = action.payload
      state.loading = false
    });
    builder.addCase(getInquiryById.rejected, (state) => {
      state.loading = false
    });
  },
});

export const { setFormEditId ,setInquiryType ,clearExtraReducers, setInquiryById,setDateFrom,setDateTo,setInquiryPageData,setInquiryByWalkin} = inquirySlice.actions;

export default inquirySlice.reducer;
